module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/googleplay-750b03765243ec5a49cf0de304131e87.png";